// extracted by mini-css-extract-plugin
export default {"list_container":"List_list_container__8ZOL4","list":"List_list__ROR21"};